import globals from '@descope-ui/theme-globals';
import { getThemeRefs } from '@descope-ui/common/theme-helpers';
import { LinkClass } from './component/LinkClass';

const globalRefs = getThemeRefs(globals);
const vars = LinkClass.cssVarList;

const link = {
  [vars.hostDirection]: globalRefs.direction,
  [vars.cursor]: 'pointer',

  [vars.textColor]: globalRefs.colors.primary.main,

  textAlign: {
    right: { [vars.textAlign]: 'right' },
    left: { [vars.textAlign]: 'left' },
    center: { [vars.textAlign]: 'center' },
  },

  _fullWidth: {
    [vars.hostWidth]: '100%',
  },

  _hover: {
    [vars.textDecoration]: 'underline',
  },

  mode: {
    secondary: {
      [vars.textColor]: globalRefs.colors.secondary.main,
    },
  },
};

export default link;
export { vars };
